<template>
  <div class="c-article-page">
    <div class="c-article-page__content">
      <Recommendation />
   </div>
    <div style="text-align: center;" v-if="isAuthenticated && resultsUrl">
      <div v-if="loading" class="block-wizard__loading">
      <svg width="124" height="58" viewBox="0 0 124 58" xmlns="http://www.w3.org/2000/svg" stroke="#0D93D2">
        <g fill="none" fill-rule="evenodd">
          <g transform="translate(44 1)" stroke-width="2">
            <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
            <path d="M36 18c0-9.94-8.06-18-18-18">
              <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
            </path>
          </g>
        </g>
        <text font-family="Arial-BoldMT, Arial" font-size="12" font-weight="bold" fill="#302D2D" stroke="none">
          <tspan x="0" y="54">{{ $t('surveyResult.loading') }}</tspan>
        </text>
      </svg>
    </div>
      <button class="btn btn-alt print-hidden" v-on:click="redirectToPrint" :disabled="token === undefined">
        {{ $t('surveyResult.download') }}
      </button>
    </div>
   <div class="result-bar" v-if="isAuthenticated && resultsUrl">
    <div class="result-bar__content">
    <router-link class="btn" :to="{ path:resultsUrl}">{{ $t('resources.backToResult') }}</router-link>
    </div>
   </div>
 </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import Recommendation from '@/components/Recommendation.vue';

/* eslint-disable no-console */
export default {
  name: 'Recommendations',
  components: {
    Recommendation,
  },
  async created() {
    this.isAuthenticated = await this.$auth.waitForSession();
    this.resultsUrl = this.assembleResultsUrl();
  },
  data() {
    return {
      resultsUrl: String,
      isAuthenticated: false,
      token: undefined,
      id: undefined,
      loading: false,
    };
  },
  methods: {
    async redirectToPrint() {
      this.loading = true;
      const namespace = _.get(this.$route, 'params.namespace');
      const querystringClean = _.get(this.$route, 'params.querystringClean');
      const paramsUrl = this.getAllParamsFromUrl(querystringClean);
      const loginFromNetSurvey = _.get(paramsUrl, 'LOG');
      const ethnosLogin = loginFromNetSurvey;
      const token = await this.$auth.waitForToken();
      const YEnterpriseSectorUser = await axios.get(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserByNamespace/${namespace}/${ethnosLogin}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const surveySessionData = await axios.get(`${process.env.VUE_APP_DIGISCORE_API}/yEnterpriseSectorUserSurveySession/${_.get(YEnterpriseSectorUser, 'data._id')}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const params = new URLSearchParams({
        ref: `${window.location.origin}/surveyPDF/${_.get(this.$route, 'params.namespace')}/${_.get(YEnterpriseSectorUser, 'data._id')}?token=${token}`,
        enterpriseName: _.get(surveySessionData, 'data.enterpriseName'),
      });
      console.log(`${window.location.origin}/surveyPDF/${_.get(this.$route, 'params.namespace')}/${_.get(YEnterpriseSectorUser, 'data._id')}?token=${token}`);
      this.loading = false;
      window.open(`${process.env.VUE_APP_DIGISCORE_API}/pdf?${params.toString()}`, '_blank');
    },
    assembleResultsUrl() {
      const namespace = _.get(this.$route, 'params.namespace');
      const querystringClean = _.get(this.$route, 'params.querystringClean');
      this.token = _.get(this.$route, 'params.token');
      this.id = _.get(this.$route, 'params.id');
      if (!namespace || !querystringClean) {
        return false;
      }
      return `survey/${namespace}/${querystringClean}`;
    },
    getAllParamsFromUrl(url) {
      const vars = url.split('&');
      const paramsArray = {};
      for (let i = 0; i < vars.length; i += 1) {
        const pair = vars[i].split('=');
        paramsArray[pair[0]] = decodeURIComponent(pair[1]);
      }
      return paramsArray;
    },
  },
};
</script>
